import { Logger } from '@ag-grid-community/core';
import { make } from 'vuex-pathify';
import { SecondaryAccountClassesService } from '../services/secondary-account-classes.service.js';

const service = new SecondaryAccountClassesService()
const state = {
  secondaryAccountClasses: []
};

const mutations = make.mutations(state);

const actions = {
  async initializeDefaultDependencies() {
    try {
      const { data } = await service.initializeDefaultDependencies();
      return data;
    } catch (error) {
      Logger.error('Error while initializing secondary account class defaults', error);
      throw error;
    }
  },

  async fetchSecondaryAccountClasses({ commit }) {
    try {
      const { data } = await service.fetchSecondaryAccountClasses();
      commit('SET_SECONDARY_ACCOUNT_CLASSES', data);
      return data
    } catch (error) {
      Logger.error('Error while Getting Secondary Account Classes', error);
      throw error;
    }
  },

  async createSecondaryAccountClass({ dispatch }, payloadOrOptions) {
    try {
      const hasOptions = Object.prototype.hasOwnProperty.call(
        payloadOrOptions,
        'payload'
      );
      const payload = hasOptions ? payloadOrOptions.payload : payloadOrOptions;
      const refresh = hasOptions ? payloadOrOptions.refresh !== false : true;
      const { data } = await service.createSecondaryAccountClass(payload);
      if (refresh) {
        await dispatch('fetchSecondaryAccountClasses');
      }
      return data
    } catch (error) {
      Logger.error('Error while Creating Secondary Account Classes', error);
      throw error;
    }
  },

  async updateSecondaryAccountClass({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateSecondaryAccountClass(id, updates);
      await dispatch('fetchSecondaryAccountClasses');
      return data
    } catch (error) {
      Logger.error('Error while Updating Secondary Account Classes', error);
      throw error;
    }
  },

  async deleteSecondaryAccountClass({ dispatch }, id) {
    try {
      const { data } = await service.deleteSecondaryAccountClass(id);
      await dispatch('fetchSecondaryAccountClasses');
      return data
    } catch (error) {
      Logger.error('Error while Deleting Secondary Account Classes', error);
      throw error; 
    }
  },
};

export default {
  state,
  mutations,
  actions
};
